import React from 'react';

const QuoteBanner = () => {
  return (
    <div className="about-banner quote-banner">
      <div className="container">
        <div className="banner-heading">
          <h1>Get Quote</h1>
          <div className="divider-shape"></div>
        </div>
      </div>
    </div>
  );
};

export default QuoteBanner;
